import { TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Button } from "@/components/ui/button";
import { CheckSquare } from "lucide-react";
import { cn } from "@/lib/utils";

interface LeadTableHeaderProps {
  onSelectAll: () => void;
  allSelected: boolean;
}

export const LeadTableHeader = ({ onSelectAll, allSelected }: LeadTableHeaderProps) => {
  return (
    <TableHeader>
      <TableRow>
        <TableHead className="w-4">
          <Button
            variant="ghost"
            size="sm"
            className={cn(
              "p-0 h-auto",
              allSelected && "text-primary"
            )}
            onClick={onSelectAll}
          >
            <CheckSquare className="h-4 w-4" />
          </Button>
        </TableHead>
        <TableHead>Email</TableHead>
        <TableHead>First Name</TableHead>
        <TableHead>Last Name</TableHead>
        <TableHead>Company</TableHead>
        <TableHead>Role</TableHead>
        <TableHead>Category</TableHead>
        <TableHead>Status</TableHead>
        <TableHead>Actions</TableHead>
      </TableRow>
    </TableHeader>
  );
};